import LocateComponent from './Locate';
export type { LocateProps } from './Locate.types';
export default LocateComponent;
